import { render, staticRenderFns } from "./BankInput.vue?vue&type=template&id=19098c20&"
import script from "./BankInput.vue?vue&type=script&lang=js&"
export * from "./BankInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports